import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import { setCharityChoice } from 'src/slices/charity'

import TableImage from '../atoms/TableImage'
import css from './CharityCard.module.scss'

export default function CharityCard({
	name,
	logo,
	bgColor = 'white',
	isSelected,
	setIsSelected,
	id,
	selected,
}) {
	const dispatch = useDispatch()
	const { permissions } = useSelector(state => state.auth)

	const handleCharity = () => {
		if (permissions.update.includes('charities')) dispatch(setCharityChoice(id))
	}

	return (
		<div
			className={css['wrapper']}
			onClick={handleCharity}>
			<div
				className={`${isSelected ? css['active'] : ''} ${css['box']}`}
				style={{ backgroundColor: bgColor }}>
				{isSelected && <i className={`fas fa-check ${css['icon']}`} />}
				<TableImage
					src={logo}
					alt={name}
					iconUnicode=''
					size='90%'
					boxStyles={{
						backgroundColor: 'transparent',
					}}
					imageStyles={{
						objectFit: 'contain',
					}}
				/>
			</div>
			<span className={css['name']}>{name}</span>
		</div>
	)
}
